module.exports = __webpack_public_path__ + "67fb82b48ec9c53e3581a378b348a72d.pdf";